import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import { app } from "../config";

const db = getFirestore(app);

const getEOEventApplications = async (userId) => {
  try {
    // Validate the user ID input
    if (!userId) {
      console.error("No user ID provided.");
      return { success: false, message: "Error: No user ID provided." };
    }

    // Step 1: Query the events collection for documents where userId matches
    const eventsQuery = query(
      collection(db, "events"),
      where("userId", "==", userId)
    );

    const eventsSnapshot = await getDocs(eventsQuery);

    if (eventsSnapshot.empty) {
      console.error("No events found for the given user ID.");
      return { success: false, message: "No events found for this user." };
    }

    // Step 2: Collect all event IDs and names from the user's events
    const events = eventsSnapshot.docs.map((doc) => ({
      id: doc.id,
      eventName: doc.data().eventName || "Unnamed Event",
    }));

    // Step 3: For each event ID, fetch the marketplace sellers who applied in mpsEventRegistration
    const eventsWithApplications = await Promise.all(
      events.map(async ({ id: eventId, eventName }) => {
        // Query mpsEventRegistration for applications with the current eventId
        const applicationsQuery = query(
          collection(db, "mpsEventRegistration"),
          where("eventId", "==", eventId)
        );

        const applicationsSnapshot = await getDocs(applicationsQuery);

        // Collect application data
        const applicationsData = applicationsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        return { eventId, eventName, applications: applicationsData };
      })
    );

    return { success: true, data: eventsWithApplications };
  } catch (error) {
    console.error("Error fetching applications:", error);
    return { success: false, message: `Error: ${error.message}` };
  }
};

export { getEOEventApplications };
